// =============================================================================
// FILE: packages/renderer/src/pages/StandaloneMapPage.tsx
// PURPOSE: Public, chrome-free full-screen view of the Global Operational Map.
//          Reachable via #map (or /map) — a shareable link to watch live users
//          across the world without the dashboard or a login.
// =============================================================================

import { useEffect, type JSX } from 'react';
import { Globe } from 'lucide-react';
import { GlobalOperationalMap } from '../components/public/GlobalOperationalMap.js';

export function StandaloneMapPage(): JSX.Element {
  useEffect(() => {
    document.documentElement.classList.add('dark');
    document.title = 'RCD² Engine — Global Operations · Live Map';
  }, []);

  return (
    <div
      data-testid="standalone-map-page"
      className="flex flex-col"
      style={{ height: '100vh', width: '100vw', background: '#04070d', overflow: 'hidden' }}
    >
      <header
        className="flex items-center gap-3 px-5 md:px-8 py-4 shrink-0"
        style={{ borderBottom: '1px solid rgba(45,212,191,0.16)', background: 'rgba(8,15,26,0.6)' }}
      >
        <Globe className="h-5 w-5 text-teal-300" />
        <div className="flex flex-col">
          <span className="text-white font-semibold tracking-wide text-sm">RCD² Engine · Global Operations</span>
          <span className="text-[10px] uppercase tracking-[0.24em] text-zinc-500">Live Network — Real-Time Users</span>
        </div>
        <span className="ml-auto flex items-center gap-2 text-[11px] text-emerald-400">
          <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" /> Live
        </span>
      </header>

      <main className="flex-1 min-h-0 p-4 md:p-8">
        <div className="h-full max-w-[1500px] mx-auto flex flex-col">
          <GlobalOperationalMap standalone />
        </div>
      </main>
    </div>
  );
}
